import * as lodash from 'lodash'
declare var _: any
let l = lodash
// Hack to use external variable if available
if (typeof _ !== 'undefined') {
  l = _
}
export { l }
// export const lodash = _
